import React from 'react'
import styled from 'styled-components'
import Chip from '@material-ui/core/Chip'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Los props $... son solo de estilo y no se pasan al Chip de MUI
// eslint-disable-next-line no-unused-vars
const ChipWithoutStyleProps = ({ $appearance, $borderColor, $fillColor, $textColor, ...rest }) => <Chip {...rest} />

const background = props => props.$fillColor || (props.$appearance === 'border' ? 'transparent' : color.background.muted)

const InfoChipStyled = styled(ChipWithoutStyleProps)`
  && {
    height: 24px;
    min-height: 24px;
    padding: 0 8px;
    box-sizing: border-box;
    font-family: ${tokens.typography.fontFamily.primary};
    font-size: 12px;
    font-weight: 400;
    color: ${props => props.$textColor || color.text.dark};
    background-color: ${background};
    border: ${props => (props.$appearance === 'border' ? `1px solid ${props.$borderColor || color.border.default}` : 'none')};
    white-space: nowrap;

    :hover,
    :focus {
      background-color: ${background};
    }

    .MuiChip-label {
      padding: 0;
    }

    /* El icono de MUI trae margen negativo y se pega al texto */
    .MuiChip-icon {
      margin: 0 6px 0 0;
      color: inherit;
    }
  }
`

export default InfoChipStyled
